import React from 'react'
import { withRouter, useHistory } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

import HelpGreyIcon from 'assets/help_grey.svg'
import LayersIcon from 'assets/layers.svg'
import routes from 'routes'
import CloseIcon from 'assets/close.svg'
import HamburgerIcon from 'assets/hamburger.svg'

const ResponsiveSidebar = (props) => {
    const history = useHistory()
    const token = localStorage.getItem('access_token')
    const isUserLoggedIn = token ? true : false
    const height = window.innerHeight
    const isMobile = useMediaQuery({ maxWidth: 767 })

    const renderPrivateContents = () => {
        return (
            <React.Fragment>
                <div
                    className={` ${
                        props.toggleState
                            ? `h-full transition ease-in-out duration-500`
                            : `h-full`
                    }`}
                >
                    <div
                        className={
                            props.location.pathname === routes.dashboard
                                ? 'px-4 py-4 bg-gray-600 w-full text-white'
                                : 'px-4 py-4  w-full'
                        }
                        onClick={() => {
                            props.toggleMenu()
                            history.push(routes.dashboard)
                        }}
                    >
                        {' '}
                        Dashboard{' '}
                    </div>

                    <div
                        className={
                            props.location.pathname === routes.search
                                ? 'px-4 py-4 bg-gray-600 w-full text-white'
                                : 'px-4 py-4  w-full'
                        }
                        onClick={() => {
                            props.toggleMenu()
                            history.push(routes.search)
                        }}
                    >
                        {' '}
                        Search{' '}
                    </div>

                    {/* <div
          className={
            props.location.pathname === routes.resources
              ? 'ml-4 lg:ml-10 cursor-pointer 0'
              : 'ml-4 lg:ml-10 cursor-pointer px-4 py-4 bg-gray-300 w-full'
          }
          onClick={() => history.push(routes.resources)}
        >
          {' '}
          Resources{' '}
        </div> */}

                    <div
                        className={
                            props.location.pathname === routes.collections
                                ? 'px-4 py-4 bg-gray-600 w-full text-white'
                                : 'px-4 py-4  w-full'
                        }
                        onClick={() => {
                            props.toggleMenu()
                            history.push(routes.collections)
                        }}
                    >
                        {' '}
                        Collections{' '}
                    </div>
                </div>

                <div className="mr-4 flex items-center justify-between">
                    {/* <a
              className=" flex items-center cursor-pointer"
              href=""
              title="Resources"
              onClick={() => {
                history.push(routes.resources);
              }}
            >
              <span className="hover:bg-gray-200 px-4 py-2 rounded-full">
                <img width="25" height="25" src={LayersIcon} />
              </span>{' '}
            </a> */}

                    {/* <div className="float-right ml-2 flex items-center ">
              <a
                className="flex items-center cursor-pointer"
                href="https://help.intrigue.io"
                target="_blank"
              >
                <span>
                  <img width="25" height="25" src={HelpGreyIcon} />
                </span>{' '}
                <span className="ml-1 font-bold">Help</span>
              </a>
            </div> */}
                </div>
            </React.Fragment>
        )
    }

    const renderPublicContents = () => {
        return (
            <React.Fragment>
                <div
                    className={
                        props.location.pathname === routes.issues
                            ? 'px-4 py-4 bg-gray-600 w-full text-white '
                            : 'px-4 py-4  w-full '
                    }
                    href=""
                    onClick={() => {
                        props.toggleMenu()
                        props.history.replace(routes.issues)
                    }}
                >
                    Issues
                </div>

                <div
                    className={
                        props.location.pathname === routes.technologies
                            ? 'px-4 py-4 bg-gray-600 w-full text-white '
                            : 'px-4 py-4  w-full '
                    }
                    href=""
                    onClick={() => {
                        props.toggleMenu()
                        props.history.replace(routes.technologies)
                    }}
                >
                    Technologies
                </div>

                {/* <div
          className={
            props.location.pathname === routes.integrations
              ? 'px-4 py-4 bg-gray-600 w-full text-white '
              : 'px-4 py-4  w-full '
          }
          href=""
          onClick={() => {
            props.toggleMenu();
            props.history.replace(routes.integrations);
          }}
        >
          Integrations
        </div> */}
            </React.Fragment>
        )
    }
    return (
        <div
            className=""
            style={{ visibility: isMobile ? 'visible' : 'hidden' }}
        >
            <img
                onClick={() => {
                    props.toggleMenu()
                }}
                src={HamburgerIcon}
                class="max-w-none cursor-pointer"
            />
            <div
                id=""
                tabIndex="0"
                className=" fixed top-0 "
                style={{
                    width: props.toggleState === true ? '100%' : '0%',
                    visibility:
                        props.toggleState === true ? 'visible' : 'hidden',
                    height: height,
                    background: 'rgba(0,0,0,0.8)',
                }}
                onBlur={() => {
                    console.log('on blur fired')
                    props.toggleState && props.toggleMenu()
                }}
            >
                <div
                    className=" bg-white z-10"
                    style={{
                        width: props.toggleState === true ? '80%' : '0%',
                        marginLeft: props.toggleState === true ? '0%' : '-80%',
                        visibility:
                            props.toggleState === true ? 'visible' : 'hidden',
                        height: height,
                        transition:
                            props.toggleState === true
                                ? 'margin 0.3s ease-in '
                                : '',
                    }}
                >
                    <div className="flex items-center justify-center py-6 border-b-2 border-gray-300">
                        <div className="text-center w-full">
                            <span className="font-bold text-lg">Explore</span>
                        </div>
                        <div className="relative">
                            <p
                                className="absolute text-white text-2xl "
                                style={{ right: '-46px', top: '-30px' }}
                                onClick={props.toggleMenu}
                            >
                                &#x2715;
                            </p>
                        </div>
                    </div>
                    <div className="mt-6">
                        {isUserLoggedIn
                            ? renderPrivateContents()
                            : renderPublicContents()}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResponsiveSidebar
